export default __webpack_public_path__ + "static/media/Deo-voyage.a853ada0.jpg";